<template>
    <div class="footer"><p>浙江核新同花顺网络信息股份有限公司版权所有</p></div>
</template>

<script>
export default {
    data () {
        return {

        }
    }
}
</script>

<style>
    .footer p {
        height: 40px;
        font-size: 12px;
        color: #b3b3b3;
        text-align: center;
        line-height: 40px;
        padding: 30px;
        margin: 0 0 0 256px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue